import React, { Component } from "react";

// Externals
import PropTypes from "prop-types";

// Material helpers
import { Switch, withStyles } from "@material-ui/core";

// Material components
import { ListItem, ListItemAvatar, Avatar, Divider, ListItemText, Tooltip, Typography } from "@material-ui/core";

// Component styles
import styles from "./styles";
import { connect } from "react-redux";
import { disableIntent, reEnableIntent, triggerBotBuilding } from "../../../../redux/actions/intentsActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
import _ from "lodash";

/**
 * NB This component is called IntentEnabled but it's also used for disabled intents.
 */
class IntentEnabled extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteIntentBtnDisabled: !this.props.administrator,
      addIntentBtnDisabled: !this.props.administrator,
      switchDeleted: this.props.intent.deleted
    };
  }

  onIntentClick = () => {
    const { intent } = this.props;
    this.props.onIntentClick(intent);
  };

  onDisableIntentClick = async intentId => {
    const { pushMessage, disableIntent } = this.props;

    if (this.state.deleteIntentBtnDisabled) {
      return;
    }

    pushMessage({ type: "info", message: "Disabling intent" });
    this.setState({ deleteIntentBtnDisabled: true });
    await disableIntent(intentId);
    this.props.triggerBotBuilding();
  };

  onReEnableIntentClick = async intentId => {
    const { pushMessage, reEnableIntent } = this.props;
    if (this.state.addIntentBtnDisabled) {
      return;
    }

    pushMessage({ type: "info", message: "Enabling intent" });
    this.setState({ addIntentBtnDisabled: true });
    await reEnableIntent(intentId);
    this.props.triggerBotBuilding();
  };

  renderActionIcon = intent => {
    const { classes } = this.props;

    return (
      <div className={classes.actionsIcon}>
        <Tooltip disableFocusListener title={this.getTooltipText(intent)} placement="top">
          <span>
            <Switch
              disabled={
                (intent.recordType === "MULTI-TASK" ? true : false) ||
                this.props.botBuildTriggered ||
                intent.name === "MainFAQIntent" ||
                !this.props.administrator
              }
              checked={!this.state.switchDeleted}
              onClick={event => {
                event.stopPropagation();

                // change switch design
                this.setState({
                  switchDeleted: !this.state.switchDeleted
                });

                if (intent.deleted) {
                  this.onReEnableIntentClick(intent.ID);
                } else {
                  this.onDisableIntentClick(intent.ID);
                }
              }}
            />
          </span>
        </Tooltip>
      </div>
    );
  };

  getIntentTitleStyles = intent => {
    if (intent.deleted) {
      return { opacity: 0.3 };
    }

    return null;
  };

  getTooltipText = intent => {
    if (!this.props.administrator) {
      return "Action disabled - Insufficient Permissions";
    }

    if (this.props.botBuildTriggered) {
      return "Action disabled. Building in progress.";
    }

    if (intent.deleted) {
      return "Enable Intent";
    }

    return "Disable Intent";
  };

  render() {
    const { classes, intent } = this.props;

    if (this.props.view === "list") {
      return (
        <React.Fragment>
          <Divider className={classes.divider} />
          <ListItem className={classes.listItem}>
            <div onClick={this.onIntentClick} className={classes.rightContainer}>
              <div className={classes.rightContainerInner}>
                <ListItemAvatar>
                  <Avatar className={classes.taskAvatar} src={this.props.currentConnection.image} />
                </ListItemAvatar>
                {/*<ListItemText primary={intent.name} classes={{ primary: classes.connectorName }} />*/}
              </div>
            </div>

            <div className={classes.verticalDivider} />

            <div onClick={this.onIntentClick} className={classes.leftContainer}>
              <ListItemText
                primary={
                  <Typography className={classes.listItemTitle} style={this.getIntentTitleStyles(intent)}>
                    {intent.title}
                  </Typography>
                }
                secondary={
                  <Typography className={classes.listItemSubtitle}>{intent.desc ? intent.desc : null}</Typography>
                }
              />
            </div>

            {this.renderActionIcon(intent)}
          </ListItem>
        </React.Fragment>
      );
      // different view for grid option. make sure to make changes on both grid and list view
    } else if (this.props.view === "grid") {
      return (
        <React.Fragment>
          {/*<Grid />*/}

          <ListItem onClick={this.onIntentClick} className={classes.gridItem}>
            <div className={classes.gridItemPadding}>
              <div className={classes.upContainer}>
                <ListItemText
                  primary={
                    <Typography className={classes.listItemTitle} style={this.getIntentTitleStyles(intent)}>
                      {intent.title}
                    </Typography>
                  }
                  // secondary={
                  //   <Typography className={classes.listItemSubtitle}>{intent.desc ? intent.desc : null}</Typography>
                  // }
                />
              </div>

              <div className={classes.downContainer}>
                <ListItemAvatar>
                  <Avatar className={classes.taskAvatar} src={this.props.currentConnection.image} />
                </ListItemAvatar>
                {/*<div className={classes.verticalDivider}></div>*/}
                {/*<ListItemText primary={intent.name} classes={{ primary: classes.connectorName }} />*/}

                {this.renderActionIcon(intent)}
              </div>
            </div>
          </ListItem>
        </React.Fragment>
      );
    }
  }
}

IntentEnabled.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  intent: PropTypes.object.isRequired,
  onIntentClick: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    currentConnection: state.connections["connection"] ? state.connections["connection"] : {},
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator",
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false
  };
}

const IntentEnabledStyled = withStyles(styles)(IntentEnabled);

export default connect(
  mapStateToProps,
  {
    disableIntent,
    reEnableIntent,
    pushMessage,
    triggerBotBuilding
  }
)(IntentEnabledStyled);
